export default __webpack_public_path__ + "static/media/sidian-bank-logo.769b7aa8.png";